/* @ngInject */
export default function RichTextComposerResource(

  $resource,
) {
  const RESOURCE_URL = '/rich_text_composer.json';
  return $resource(RESOURCE_URL);
}
